import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable, forkJoin, pipe } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import { of } from 'rxjs';
// import { ApplicationQuestionsDTO } from '../DTOs/Organisations/Models/ApplicationQuestionsDTO';
// import { SurveyNameDTO } from '../DTOs/Comms/Models/SurveyNameDTO';
// import { EmailTemplateDTO } from '../DTOs/Comms/Models/EmailTemplateDTO';
import { AppConfigService, AppConfig } from '../services/app-config.service';
import { TextRequestMessage } from '../DTOs/Comms/Models/TextRequestMessage';
import { EmailRequestMessage } from '../DTOs/Comms/Models/EmailRequestMessage';
import { AuthService } from '../auth/auth.service';
import { SurveyDTO } from 'src/DTOs/PatientProcedures/Models/SurveyDTO';
import { tap, combineLatest, shareReplay, map } from 'rxjs/operators';
import { EmailTemplateDTO } from 'src/DTOs/Comms/Models/EmailTemplateDTO';

export interface MessageItemDto {
  id: string;
  messageSetId: string;
  messageName: string;
  messageSetName: string;
}

export interface StepDefinitionStub {
  flowId: string;
  isGlobalFlow: boolean;
  flowName: string;
  stepId: string;
  stepName: string;
}

@Injectable()
export class CommService {

  public appConfig: AppConfig = new AppConfig();

  constructor(private http: HttpClient,
    private authService: AuthService,
    private appConfigService: AppConfigService) {

    this.appConfig = this.appConfigService.getConfig();

    if (environment.debug_mode) {
      console.log("CommService, comm_api_url: " + this.appConfig.comm_api_url);
    }

  }

  GetCaseApplicationQuestions(filter: string, questionsFilter: string[] = []): Observable<any> {

    debugger;
    const url: string = this.appConfig.comm_api_url + environment.comm_api_surveys + 'questions';
    if (environment.debug_mode) {
      console.log("GetCaseApplicationQuestions: " + url);
    }

    return this.http.post(url,{questions:questionsFilter,filter:filter})
      .pipe(shareReplay(1));


  }

  GetProcedureProtocolMessages(search: string = null): Observable<any> {
    const url: string = `${this.appConfig.oc_api_url}${environment.oc_api_procedure_protocols_url}messages?search=${search}`;
    const curnexUrl: string = `${this.appConfig.curnex_api_url}webapp/${this.authService.getClaims().organization_id}/stepstubs`;
    var obs = forkJoin([
      this.http.get<MessageItemDto[]>(url),
      this.http.get<StepDefinitionStub[]>(curnexUrl)
    ]).pipe(map(x => {
      var fullResult = [];
      var result = x[0]; // legacy result
      var curnexResult = x[1];
      curnexResult.forEach(c => fullResult.push({
        id: c.stepId,
        messageSetId: c.flowId,
        messageName: c.stepName,
        messageSetName: c.isGlobalFlow ? `${c.flowName} (Curnex global)` : `${c.flowName} (Curnex)`
      }));
      result.forEach(c => fullResult.push(c));
      return fullResult;
    }));
    return obs;
  }

  GetQuestionByExternalId(externalId: string): Observable<any> {

    

    const url: string = this.appConfig.comm_api_url + environment.comm_api_surveys + 'question?externalId=' + externalId;

    if (environment.debug_mode) {
      console.log('GetQuestionByExternalId: ' + url);
    }

    return this.http.get(url);


  }

  GetSurveyByExternalId(externalId: string): Observable<any> {

    

    const url: string = this.appConfig.comm_api_url + environment.comm_api_surveys + externalId + "?includeDeleted=false";

    if (environment.debug_mode) {
      console.log('GetSurveyByExternalId: ' + url);
    }

    return this.http.get(url);


  }

  GetSurveyNames(): Observable<any> {

    

    const url: string = this.appConfig.comm_api_url + environment.comm_api_surveys + 'surveys';

    if (environment.debug_mode) {
      console.log('GetSurveyNames: ' + url);
    }

    return this.http.get(url);

  }

  search(filterValue: { name: string } = { name: '' }, page = 1): Observable<SurveyDTO[]> {
    return this.http.get<SurveyDTO[]>(this.appConfig.comm_api_url + environment.comm_api_surveys + 'surveys')
      .pipe(
        combineLatest((response: SurveyDTO[]) => {
          response = response
            .filter(s => s.surveyId.toUpperCase().includes(filterValue.name.toUpperCase()) || s.surveyTitle.toUpperCase().includes(filterValue.name.toUpperCase()))
          return response;
        })
      );
  }


  GetEmailTemplates(): Observable<any> {

    

    const url: string = this.appConfig.comm_api_url + environment.comm_api_email_templates_url;

    if (environment.debug_mode) {
      console.log('GetEmailTemplates: ' + url);
    }

    return this.http.get(url)
      .pipe(
        tap((r: any) => {
          r.forEach(t => {
            try { t.labels = JSON.parse(t.labels); } catch { t.labels = []; }
          });
        }),
        shareReplay(1));

  }

  SendTextMessage(sms: TextRequestMessage, allowImages: boolean): Observable<any> {

    

    const url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + 'chatmessage/sms?allowImages=' + (allowImages ? 'true' : 'false');

    if (environment.debug_mode) {
      console.log('SendTextMessage: ' + url);
    }

    return this.http.post(url, sms);

  }

  SendEmail(email: EmailRequestMessage, allowImages: boolean): Observable<any> {

    

    const url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + 'chatmessage/email?allowImages=' + (allowImages ? 'true' : 'false');

    if (environment.debug_mode) {
      console.log('SendEmail: ' + url);
    }

    return this.http.post(url, email);

  }

  getQuestionResponses(questionIds: string[]): Observable<any> {
    

    const url: string = this.appConfig.comm_api_url + environment.comm_api_surveys + 'responses?questionIds=' + questionIds.join("&questionIds");

    return this.http.get(url);
  }

}

export interface ISurveyResponse {
  total: number;
  results: SurveyDTO[];
}
